import type { IFeatureFlagProvider } from './types'
import { FlagsmithProvider } from './providers/FlagsmithProvider'

// Punto único de acoplamiento con el proveedor.
// El resto de la app importa SOLO desde aquí, nunca del adaptador concreto.
export const featureFlagProvider: IFeatureFlagProvider = new FlagsmithProvider()
export * from './types'
export * from './flags'
